import React, { Fragment } from 'react';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";

/**
 * Dropdown to select users innan organisation that qualify to register and activate a child. Called by the create child function, this used to default to
 * the person creating the child. Note* the selected use will also be given editor rights for the child. User types in the list are org lsw and staff, adopters, connected carers and foster parents
 * Also checks the users have an email set.
 * @param use_tye        responsibleAdults
 * @returns {JSX.Element}
 *
 */
const DropdownResponsibleAdult = ( { control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, team_id, organisation_id, filter } ) =>
{
    const url = '/organisation/current/users?user_type=responsibleAdult';
    const fields = { url: url, keyFieldName: 'user_id', labelFieldName: 'fullNameType', additionalFields: ['idusers', 'userTypeId'] }
    const [ loading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownResponsibleAdult;
